module.exports = "/static/assets/12e69a59db0f0c697eaaf1abbcad902f.svg";